var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Culture"},[_c('div',{staticClass:"CultureBox"},_vm._l((_vm.responsiveCultureList),function(item,index){return _c('div',{key:item.Id,staticClass:"culture-card"},[_c('img',{staticClass:"background-image",style:({
       // width: item.AboutImgSize[0].width + '%',
        // height: item.AboutImgSize[0].height + '%',
        // position: 'absolute',
        //  left: item.AboutPosition[0].x + '%',
        // top: item.AboutPosition[0].y + '%',
      }),attrs:{"src":item.Background,"alt":"Background"}}),_c('div',{staticClass:"mask-image"}),_c('div',{staticClass:"Culture-description"},[_c('h2',{style:({ color: item.FontColor ,fontWeight:400})},[_vm._v(_vm._s(item.title))]),_c('p',{style:({ color: item.DescriptionColor }),domProps:{"innerHTML":_vm._s(item.description )}})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }